

import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import ChatList from "../components/ChatList";


const ChatListPage = () => {
  return (
    <div>

        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Chats  </h5><Breadcrumb title="chats" /></div>
        <ChatList/>

        

    </div>
  );
};


export default ChatListPage;
